export default {
  drawerPaper: {
    maxWidth: 792,
    padding: '30px 50px'
  },
  title: {
    position: 'relative',
    top: '15px',
    left: '1px',
    marginBottom: '24px',
    color: '#0b1829'
  },
  infoAnchor: {
    fontFamily: 'Gilroy-SemiBold',
    fontWeight: 600,
    fontSize: 12,
    color: '#787b80',
    lineHeight: 'normal',
    letterSpacing: 'normal',
    display: 'flex',
    alignItems: 'center'
  },
  number: {
    fontFamily: 'Gilroy-SemiBold',
    fontSize: 20,
    fontWeight: 500,
    lineHeight: '32px',
    color: '#0b1829'
  },
  detail: {
    marginTop: 8,
    marginBottom: 15,
    display: 'inline-flex'
  },
  link: {
    paddingLeft: 5
  },
  button: {
    padding: '20px',
    letterSpacing: 'normal',
    width: '182px',
    height: '56px'
  }
};
